import { generateId } from '../../helpers';
import { CatalogProduct } from './api-shared.models';

export enum ChatResponseTypeEnum {
  Unset = 0,
  Bad = 1,
  Good = 2,
}
export interface EvaluateChatRequest {
  ProductCatalogConversationId: string;
  ResponseTypeEnum: ChatResponseTypeEnum;
  Comment: string;
}
export interface ChatRequest {
  CustomerId: string;
  UserPrompt: string;
  ThreadId?: string;
  OrderEntryHeaderId?: string;
}
export interface ChatResult {
  ProductCatalogConversationId: string;
  Message: string;
  ThreadId: string;
  Products: CatalogProduct[];
}

export type ChatMessage = {
  id: string;
  prompt: string;
  message: string;
  source: 'user' | 'system' | 'thread';
  productIds: string[];
  timestamp?: string;
  response?: ChatResponseTypeEnum;
  productCatalogConversationId?: string;
};
export type ChatGreeting = string;
export type ChatPrompt = {
  ProductCatalogConversationPromptId: string;
  ProductCatalogConversationPromptContent: string;
  IsActive: boolean;
  CreateDate: Date | string;
  ChangeDate: Date | string;
  DeleteDate?: Date | string;
};

export const getChatTimestamp = () => {
  const now = new Date();
  const initTime =
    now.toLocaleDateString([], {
      weekday: 'short',
      month: 'long',
      day: '2-digit',
    }) +
    ', ' +
    now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return initTime;
};

export const getChatFollowUpMessage = (productCount: number): ChatMessage => {
  const msgSet: string[] = [];

  if (productCount >= 0) {
    msgSet.push(
      ...[
        'Is there anything else I can help you with?',
        "If this isn't quite, tell me what else you need and I'll look again.",
      ]
    );
  }
  if (productCount >= 1) {
    msgSet.push(
      ...[
        'Let me know if you need help narrowing down your results.',
        'I can help you narrow down your search or find something else. Just let me know!',
        'Are you looking for something specific?',
        "Let me know what you're looking for in this product, and I'll refine the search.",
        "I'm happy to answer more questions about this or help with other products.",
        "I can share more details about this item or others you're considering.",
        'Looking for something else? I can show you more options.',
      ]
    );
  }
  if (productCount >= 4) {
    msgSet.push(...['Click "View More" to browse additional products or me ask about something.']);
  }

  const result: ChatMessage = {
    id: generateId(),
    prompt: '',
    message: msgSet[Math.floor(Math.random() * msgSet.length)],
    productIds: [],
    source: 'system',
    timestamp: getChatTimestamp(),
  };
  return result;
};

export const InitChatName = 'Sage';

export const InitChatGreetings = ["I'm here if you need help finding something"];
export const InitChatMessage: ChatMessage = {
  id: 'init',
  prompt: '',
  message: `Hi, I’m ${InitChatName}. How can I help you today?`,
  source: 'system',
  productIds: [],
  timestamp: getChatTimestamp(),
};

export const InitChatPrompts = [
  'Find an apple juice that has less than 30g of sugar per serving?',
  'Ideas for chocolate dessert that are frozen?',
  "I'm looking for spicy potato chips.",
  'How many ounces are in a pound?',
  'List ingredients to make fish tacos.',
  'Show me seasonal products produced in Wisconsin.',
  'Gleuten free options for a roux recipe.',
  'Lower cost alternatives to our condiments.',
  'Minnesota state of origin steak options.',
  'Show me ingredients that you would find on a gluten free menu.',
  'Show me ingredients that you would find on a gluten free menu.',
  'Show me sanitary products.',
  'Find low calorie juices.',
];
